import React from 'react';
import { Link } from 'react-router-dom';
import { Message } from 'semantic-ui-react';

import * as routes from '../routes.json';

const PasswordForgetLink = () => (
  <Message>
    <p>Forgot your password? </p>
    <Link to={routes.passwordForget}>Password Reset</Link>
  </Message>
);

export default PasswordForgetLink;



// WEBPACK FOOTER //
// ./src/components/PasswordForgetLink.jsx